import React, { useState, useEffect } from 'react';
import api from '../../common/lib/api';
import moment from 'moment';
import Managed, { useManaged } from '../../common/components/Managed';
import AsyncButton from '../../common/components/AsyncButton';
import StaticTable from '../../common/components/StaticTable';

const DEFAULT_STATE = {};
const DEFAULT_ITEMS_FOR_SALE = ['C1'];
const DEFAULT_START_DATE = moment().subtract(6, 'months').format('YYYY-MM-DD');
const DEFAULT_END_DATE = moment().format('YYYY-MM-DD');

const RESULT_FIELDS = [
  {
    id: 'item',
    name: 'Item',
  },
  {
    id: 'company',
    name: 'Company',
  },
  {
    id: 'date',
    name: 'Date',
    type: 'datetime'
  },
  {
    id: 'count',
    name: 'Count',
    type: "number"
  },
];

export default function Page() {
  // const params = new URLSearchParams(window.location.search);
  const [state, setState, setError] = useManaged(DEFAULT_STATE);

  const [itemsForSale, setItemsForSale] = useState(DEFAULT_ITEMS_FOR_SALE);
  const [startDate, setStartDate] = useState(DEFAULT_START_DATE);
  const [endDate, setEndDate] = useState(DEFAULT_END_DATE);
  const [result, setResult] = useState(null);

  const data = state.data || {};

  const saleItems = data.saleItems || [];

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/item-sales-report');
        setState(data.data);
      } catch (e) {
        setError(e);
      }
    })();
  }, [setError, setState]);

  async function start() {
    if (!itemsForSale || !itemsForSale.length) {
      return alert('Please select at least one product');
    }
    if (!startDate || !endDate) {
      return alert('Please select a date range');
    }

    const { data } = await api.get('/item-sales-report/data', {
      params: {
        itemsForSale,
        startDate,
        endDate,
      },
    });

    setResult(data.data);
  }

  return (
    <Managed state={state}>
      <h1>Item Sales Report</h1>
      <div className='print-hide'>
        <p>
          Please select products: <br />
          <select
            multiple
            onChange={(e) => {
              let value = Array.from(e.target.selectedOptions, (option) => option.value);
              setItemsForSale(value);
            }}
          >
            {saleItems.map((item) => {
              return <option selected={itemsForSale.includes(item)}>{item}</option>;
            })}
          </select>
        </p>
        <p>
          Please select start date: <br />
          <input type='date' value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        </p>
        <p>
          Please select end date: <br />
          <input type='date' value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </p>
        <AsyncButton onClick={start}>Get Data</AsyncButton>
      </div>
      {result && <StaticTable items={result} fields={RESULT_FIELDS} />}
    </Managed>
  );
}
